<template>
  <div>
    <el-dialog :title="$parent.isAdd
        ? $t('message.addedAutomaticQuotationRule')
        : $t('message.editAutomaticQuotationRule')
      " :close-on-click-modal="false" :visible.sync="$parent.autolDialogVisible" width="1308px" center>
      <div class="box">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <!-- 生效日期： -->
          <el-form-item :label="$t('message.effectiveDate') + '：'" prop="start_at">
            <el-col :span="5">
              <el-form-item prop="date1">
                <!-- 生效开始时间 -->

                <el-date-picker v-model="ruleForm.start_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('message.effectiveStartTime')">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item prop="end_at">
                <el-date-picker v-model="ruleForm.end_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('message.validityEndTime')" :default-time="'23:59:59'">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6"> </el-col>
          </el-form-item>
          <!-- 计费方式： -->
          <el-form-item :label="$t('message.billingWay') + '：'" prop="chargeFinal">
            <el-col :span="5">
              <!-- 单发送方式 -->
              <el-radio :label="'2'" v-model="ruleForm.chargeFinal">{{
                $t("message.singleTransmissionMode")
              }}</el-radio>
            </el-col>
            <el-col :span="5">
              <!-- 单箱计费后累加 -->
              <el-radio :label="'1'" v-model="ruleForm.chargeFinal">{{
                $t("message.accumulatesAfterChargingForASingleBox")
              }}</el-radio>
            </el-col>
            <el-col :span="6"> </el-col>
          </el-form-item>
          <!-- 计价类型： -->
          <el-form-item :label="$t('message.valuationType') + '：'" prop="chargeMethod">
            <el-col :span="5">
              <!-- 重量 -->
              <el-radio :label="'weight'" v-model="ruleForm.chargeMethod">{{
                $t("message.weight")
              }}</el-radio>
            </el-col>
            <el-col :span="5">
              <!-- 体积 -->
              <el-radio :label="'volume'" v-model="ruleForm.chargeMethod">{{
                $t("message.volume")
              }}</el-radio>
            </el-col>
            <el-col :span="6"> </el-col>
          </el-form-item>
          <!-- 计抛方式： -->
          <el-form-item :label="$t('message.meterBehindWay') + '：'" prop="chargeWhole">
            <el-col :span="5">
              <!-- 单箱 -->
              <el-radio :label="'single'" v-model="ruleForm.chargeWhole">{{
                $t("message.singleBox")
              }}</el-radio>
            </el-col>
            <el-col :span="5">
              <!--整票 -->
              <el-radio :label="'whole'" v-model="ruleForm.chargeWhole">{{
                $t("message.theTicket")
              }}</el-radio>
            </el-col>
            <el-col :span="6"> </el-col>
          </el-form-item>
          <!-- 取整顺序： -->
          <el-form-item :label="$t('message.takeTheWholeOrder') + '：'" prop="ceilOrder">
            <el-col :span="5">
              <!-- 先取整 -->
              <el-radio :label="'before'" v-model="ruleForm.ceilOrder">{{
                $t("message.takeTheFirst")
              }}</el-radio>
            </el-col>
            <el-col :span="5">
              <!-- 后取整 -->
              <el-radio :label="'after'" v-model="ruleForm.ceilOrder">{{
                $t("message.afterTheWhole")
              }}</el-radio>
            </el-col>
            <el-col :span="6"> </el-col>
          </el-form-item>
          <!-- 抛重比例 -->
          <el-form-item :label="$t('message.castHeavyProportion') + '：'" prop="rate">
            <el-col :span="5">
              <el-input v-model="ruleForm.rate" class="input" placeholder="例如:6000"></el-input>
            </el-col>
            <el-col :span="5">
              <!-- 是否计半抛 -->
              <el-checkbox v-model="ruleForm.is_half">{{
                $t("message.whetherToCountHalfCast")
              }}</el-checkbox>
            </el-col>
            <el-col :span="6"> </el-col>
          </el-form-item>
          <!-- 重量/体积取整区间： -->
          <el-form-item :label="$t('message.TheWeightVolumeIsRounded') + '：'" prop="region">
            <div class="row" v-for="(item, index) in ruleForm.weightRange" :key="index">
              <el-col :span="5">
                <el-input v-model="item.min" class="input" placeholder="区间开始值"></el-input>
              </el-col>
              <el-col :span="5">
                <el-input v-model="item.max" class="input" placeholder="区间结束值"></el-input>
              </el-col>
              <el-col :span="5">
                <el-select v-model="item.ceilMethod" placeholder="取整区间选择">
                  <el-option v-for="item in ceilMethodOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-button size="mini" type="success" @click="delWeightRange(index)" class="dark">
                  {{ $t("message.delete") }}
                </el-button>
              </el-col>
            </div>
            <div class="add">
              <el-button size="mini" type="success" @click="addWeightRange">
                {{ $t("message.add") }}
              </el-button>
            </div>
          </el-form-item>
          <!-- 计价区间： -->
          <el-form-item :label="$t('message.pricingInterval') + '：'" prop="region">
            <div class="row" v-for="(item, index) in ruleForm.range" :key="index">
              <el-col :span="5">
                <el-input v-model="item.min" class="input" placeholder="区间开始值"></el-input>
              </el-col>
              <el-col :span="5">
                <el-input v-model="item.max" class="input" placeholder="区间结束值"></el-input>
              </el-col>
              <el-col :span="5">
                <el-input v-model="item.price" class="input" placeholder="价格"></el-input>
              </el-col>
              <el-col :span="3">
                <el-select v-model="item.chargePerMethod" placeholder="固定价格">
                  <el-option v-for="item in chargePerMethodOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select v-model="item.clientShow" placeholder="物流界面是否显示">
                  <el-option v-for="item in clientShowOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="1">
                <el-button size="mini" type="success" @click="delRange(index)" class="dark">
                  {{ $t("message.delete") }}
                </el-button>
              </el-col>
            </div>
            <div class="add">
              <el-button size="mini" type="success" @click="addRange">
                {{ $t("message.add") }}
              </el-button>
            </div>
          </el-form-item>
          <!-- 额外收费 -->
          <el-form-item :label="$t('message.additionalCharge') + '：'" prop="region">
            <div class="row">
              <el-col :span="5">
                <div class="input">
                  <el-input v-model="ruleForm.otherPer" placeholder="区间开始值"></el-input>
                </div>
              </el-col>
              <el-col :span="2">
                <!-- 单箱 -->
                {{ $t("message.singleBox") }}
              </el-col>
            </div>

            <div class="row">
              <el-col :span="5">
                <div class="input">
                  <el-input v-model="ruleForm.otherWhole" placeholder="区间开始值"></el-input>
                </div>
              </el-col>
              <el-col :span="2">
                <!--整票 -->
                {{ $t("message.theTicket") }}
              </el-col>
            </div>
          </el-form-item>
          <!-- 自动签收天数 -->
          <el-form-item :label="$t('message.daysOfAutomaticReceipt') + '：'" prop="sign_receive_days">
            <el-col :span="8">
              <el-input v-model="ruleForm.sign_receive_days" placeholder="请输入业务发货后自动签收的天数"></el-input>
            </el-col>
          </el-form-item>
          <!-- 注意事项： -->
          <!-- <el-form-item
            :label="$t('message.mattersNeedingAttention') + '：'"
            prop="region"
          >
          
          </el-form-item> -->
          <p style="color: #fa5058">
            {{ $t("message.mattersNeedingAttention") }}:
            {{ $t("message.wuliuMattersNeedingAttention") }}
          </p>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.autolDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 新增 -->
        <el-button type="primary" @click="logisticsAddRuleConfig" v-if="$parent.isAdd">{{ $t("message.save")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="logisticsUpdateRuleConfig" v-else>{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    ruleForm: { type: Object },
  },
  data() {
    return {
      rules: {
        start_at: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        end_at: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        sign_receive_days: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        chargeFinal: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        chargeMethod: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        rate: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        ceilOrder: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        chargeWhole: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
      ceilMethodOptions: [
        {
          value: "0.5",

          label: "向上取0.5",
        },
        {
          value: "1",

          label: "向上取1",
        },
      ],
      chargePerMethodOptions: [
        {
          value: "1",

          label: "固定价",
        },
        {
          value: "2",

          label: "单价",
        },
      ],
      clientShowOptions: [
        {
          value: "1",

          label: "显示",
        },
        {
          value: "2",

          label: "不显示",
        },
      ],
    };
  },
  methods: {
    // 新增
    logisticsAddRuleConfig() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.ruleForm));
          datas.is_half = datas.is_half ? 1 : 0;
          this.$api.siteConfiguration
            .logisticsAddRuleConfig(datas)
            .then((res) => {
              this.$message.success(res.msg);
              this.$parent.autolDialogVisible = false;
              this.$parent.logisticsDetail();
            });
        }
      });
    },
    // 修改
    logisticsUpdateRuleConfig() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          let datas = JSON.parse(JSON.stringify(this.ruleForm));
          datas.is_half = datas.is_half ? 1 : 0;
          this.$api.siteConfiguration
            .logisticsUpdateRuleConfig(datas)
            .then((res) => {
              this.$message.success(res.msg);
              this.$parent.autolDialogVisible = false;
              this.$parent.logisticsDetail();
            });
        }
      });
    },
    //追加重量/体积取整区间
    addWeightRange() {
      this.ruleForm.weightRange.push({});
    },
    // 删除重量/体积取整区间
    delWeightRange(i) {
      this.ruleForm.weightRange.splice(i, 1);
    },
    //追加计价区间
    addRange() {
      this.ruleForm.range.push({});
    },
    // 删除计价区间
    delRange(i) {
      this.ruleForm.range.splice(i, 1);
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

/deep/.line {
  text-align: center;
}

/deep/.input {
  width: 90%;
}

/deep/.el-date-editor {
  width: 90%;

  .el-input__inner {
    padding-right: 10px;
  }
}

.box {
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
}

.row {
  margin-bottom: 20px;
  overflow: hidden;

  /deep/.el-select {
    width: 90%;
  }

  i {
    font-size: 22px;
    margin-top: 10px;
    cursor: pointer;
  }
}

.add {
  i {
    font-size: 22px;
    color: #b4272d;
    cursor: pointer;
  }
}
</style>